<template>
  <ol class="list-counter mt-3 mb-5">
    <li v-for="item in items" v-bind:key="item" class="text-xl mb-6">
      {{ item }}
    </li>
  </ol>
</template>

<script>
export default {
  name: 'NumberedList',
  props: {
    /**
     * [
     *    'About you',
     *    'Where you live',
     *    'Work and Finances'
     * ]
     */
    items: Array
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .list-counter {
    padding: 0;
    list-style-type: none;
  }

  .list-counter li {
    counter-increment: step-counter;
    display: flex;
  }

  .list-counter li::before {
    content: counter(step-counter);
    min-width: 2.4em;
    @apply bg-polred rounded-full h-12 w-12 flex items-center justify-center text-white mr-5 -mt-2 font-bold
  }

</style>
